<script>
import { BButtonToolbar } from "bootstrap-vue";

export default {
  extends: BButtonToolbar
};
</script>